import React, { Fragment } from "react";
import { ListGroup, ListGroupItem } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import Icon from "@fortawesome/react-fontawesome";
import {
  faAsterisk,
  faKey,
  faUser,
  faMotorcycle
} from "@fortawesome/fontawesome-free-solid";
import { compose, setDisplayName, flattenProp, defaultProps } from "recompose";
import { parse, format } from "date-fns";
import Steps, { Step } from "rc-steps";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { currentStatus } from "./EventSection";
import { faClipboard, faCreditCard } from "@fortawesome/free-regular-svg-icons";

const printSteps = (state_position, contract_states) => {
  return contract_states.map((state, index) => {
    let stateName;
    let icon;
    switch (state) {
      case "in_service":
        stateName = "In service";
        icon = "wrench";
        if (state_position > index) {
          stateName = "Service Completed";
        }
        if (contract_states[state_position] === "waiting_for_service") {
          stateName = "Waiting for service";
        }
        if (contract_states[state_position] === "waiting_for_parts") {
          stateName = "Waiting for parts";
        }
        if (contract_states[state_position] === "hold") {
          stateName = "On hold";
        }
        break;

      case "pending_diagnostic":
        stateName = "Pending diagnostic";
        icon = faClipboard;

        if (state_position > index) {
          stateName = "Services Confirmed";
        }
        if (contract_states[state_position] === "in_diagnostic") {
          stateName = "In diagnostic";
        }
        if (contract_states[state_position] === "approve_diagnostic") {
          stateName = "Approve diagnostic";
        }
        if (
          contract_states[state_position] === "customer_confirmation_needed"
        ) {
          stateName = "Customer confirmation needed";
        }
        

        break;

      case "waiting_for_payment":
        stateName = "Waiting for payment";
        icon = faCreditCard;
        if (state_position > index) {
          stateName = "Payment Received";
        }
        break;

      case "waiting_for_pickup":
        stateName = "Waiting for pickup";
        icon = "svg";
        if (state_position > index) {
          stateName = "Scooter Picked Up";
        }
        break;

      case "cancelled":
        stateName = "Cancelled";
        icon = "exclamation-triangle";
        break;

      default:
        stateName = state;
        icon = undefined;
    }

    if (
      state === "in_service" ||
      state === "pending_diagnostic" ||
      state === "waiting_for_payment" ||
      state === "waiting_for_pickup"
    ) {
      return (
        <Step
          className="tracker"
          title={stateName}
          icon={<Icono type={icon} />}
        />
      );
    }
    if (
      state === "cancelled" &&
      contract_states[state_position] === "cancelled"
    ) {
      return (
        <Step
          className="tracker"
          title={stateName}
          status={"error"}
          icon={<Icono type={icon} />}
        />
      );
    }
    return null;
  });
};

const Icono = ({ type }) => {
  if (type === "svg") {
    return (
      <i className={`rcicon`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="25"
          viewBox="0 0 87 55"
          style={{ verticalAlign: "-.125em" }}
        >
          <g
            id="Group_2344"
            data-name="Group 2344"
            transform="translate(476.36 1843.072)"
          >
            <path
              id="Path_1079"
              data-name="Path 1079"
              d="M-234.69-1708.093h-.015a3.368,3.368,0,0,0-2.4.994,3.444,3.444,0,0,0-.98,2.473,3.443,3.443,0,0,0,3.4,3.436h.049a3.518,3.518,0,0,0,3.41-3.5A3.457,3.457,0,0,0-234.69-1708.093Z"
              transform="translate(-168.811 -95.63)"
              fill="currentColor"
            />
            <path
              id="Path_1080"
              data-name="Path 1080"
              d="M-389.333-1812.259c-1.205-3.564-4.051-5.649-8.459-6.2a17.906,17.906,0,0,0-2.237-.121c-.612,0-1.225.02-1.817.039-.464.015-.907.029-1.344.035l-.022-.04-.031-.056c.283-2.832-.758-4.526-3.181-5.176a1.385,1.385,0,0,1-.352-.514c-.785-1.776-1.562-3.59-2.314-5.345l-.417-.974a10.2,10.2,0,0,0,1.267.1,2.61,2.61,0,0,0,.973-.153c1.152-.454,1.152-1.839,1.152-3.593q0-.929,0-1.858c.006-1.444.011-2.937-.015-4.409a2.271,2.271,0,0,0-1.416-2.448,2.84,2.84,0,0,0-.8-.1h0a5.351,5.351,0,0,0-.747.057c-.127.018-.255.039-.38.063a6.224,6.224,0,0,0-4.86,4.085h-2.338a2.131,2.131,0,0,0-2.128,2.128,1.419,1.419,0,0,0,.015.2,1.561,1.561,0,0,0,.6,1.3,2.105,2.105,0,0,0,1.51.633h2.375q.019.051.038.1A3.6,3.6,0,0,0-417.6-1833a8.185,8.185,0,0,0-1.152,5.34c.15,2.131.236,4.307.32,6.411.058,1.464.118,2.978.2,4.467a3.268,3.268,0,0,1-1.337,2.906l-.4.342c-2.459,2.081-5,4.233-8.234,4.7a15.164,15.164,0,0,1-2.17.142c-1.351,0-2.749-.138-4.1-.271l-.509-.05a1.564,1.564,0,0,1-1.366-1.883c.263-3.555,1.42-4.709,3.078-5.348a2.1,2.1,0,0,0,.983-.991,5.765,5.765,0,0,0-.994-5.513,2.692,2.692,0,0,1-.162-1.211,6.086,6.086,0,0,0-1.359-4.471,5.024,5.024,0,0,0-3.868-1.71h-.033c-2.488.013-4.925.015-6.77.015h-6.453q-1.68,0-3.358,0a5.006,5.006,0,0,0-5.248,5.206c-.009.58-.006,1.165,0,1.682,0,.077,0,.152,0,.227a21.584,21.584,0,0,0-10.8,8.3,34.359,34.359,0,0,0-4.888,12.855,2.963,2.963,0,0,0,.274,2.427,2.476,2.476,0,0,0,1.966.681c.166,0,.342-.006.538-.018.12-.007.232-.011.334-.011.886,0,1.256.218,1.565,1.439a13.125,13.125,0,0,0,4.8,7.333,13.7,13.7,0,0,0,8.357,2.728q.243,0,.488-.008a13.477,13.477,0,0,0,12.6-10.831c.041-.189.1-.387.17-.614h2.321l4.936,0,4.936,0c2.658,0,4.836,0,6.854.009l.779.005c.327,0,.654.006.981.006a13.046,13.046,0,0,0,6.9-1.44c.76,6.577,4.142,10.744,10.064,12.394a14.629,14.629,0,0,0,3.918.559,12.6,12.6,0,0,0,9.808-4.81c3.858-4.588,4.386-9.769,1.573-15.409,1.426-.106,2.42-.367,2.935-1.121C-388.547-1809.4-388.789-1810.651-389.333-1812.259Zm-19.591-27.2v5.027a2.513,2.513,0,0,1-2.513-2.513A2.513,2.513,0,0,1-408.924-1839.461Zm-47.586,14.413a.991.991,0,0,1,1.135-1.043q1.771,0,3.542,0,1.931,0,3.861,0c2.552,0,5.912.007,9.272.065a1.718,1.718,0,0,1,1.073.868,4.972,4.972,0,0,1,.082,1.743c-.007.116-.014.234-.02.353h-18.961c0-.11,0-.218-.006-.324C-456.544-1824-456.553-1824.528-456.51-1825.048Zm-2.044,33.73,0,.292h0v-.292a9.546,9.546,0,0,1-6.217-2.352,8.549,8.549,0,0,1-2.92-5h18.3A9.3,9.3,0,0,1-458.554-1791.318Zm43.073-16.843a10.426,10.426,0,0,1-1.414,2.117l-.13.164a7.6,7.6,0,0,1-6.4,3.091h-.044c-6.693-.026-13.819-.038-23.1-.038q-6.081,0-12.162,0t-12.161,0h-1.156a29.157,29.157,0,0,1,6.253-12.311,10.744,10.744,0,0,1,8.5-3.824c.1,0,.2,0,.3,0,2.389.049,4.966.072,8.11.072,1.949,0,3.93-.009,5.846-.017s3.894-.017,5.841-.017h.383a10.1,10.1,0,0,0-3.575,7.872c-.094,3.289,1.531,5.391,4.576,5.919a31.482,31.482,0,0,0,5.335.495,22.226,22.226,0,0,0,2.46-.132c4.634-.519,8.053-3.451,11.36-6.286l.064-.055a6.472,6.472,0,0,0,2.386-5.436c-.08-2.295-.18-4.626-.277-6.88q-.1-2.223-.185-4.446c-.006-.152-.015-.306-.025-.461a5.221,5.221,0,0,1,.05-1.527,1.074,1.074,0,0,1,.512-.49,1.171,1.171,0,0,1,.51.456c.483,1.059.948,2.153,1.4,3.21.595,1.4,1.209,2.843,1.877,4.241a5.377,5.377,0,0,0,2.007,2.173,2.161,2.161,0,0,1,1.175,1.6,1.907,1.907,0,0,1-.821,1.58C-410.729-1814.866-413.752-1812.072-415.481-1808.162Zm18.28,14.1a9.559,9.559,0,0,1-6.687,2.743,9.281,9.281,0,0,1-4.051-.918,9.407,9.407,0,0,1-5.346-9.621c.013-.105.023-.212.032-.318.054-.615.076-.87.7-1.054a55.926,55.926,0,0,0,7.355-2.729l.085-.039a12.118,12.118,0,0,1,4.712-1.469,4.376,4.376,0,0,1,.628.044l.042.006h.042c3.041,0,3.2.177,4.333,2.509A9.453,9.453,0,0,1-397.2-1794.065Zm3.424-17.393c-.3.01-.6.019-.9.019-.259,0-.487-.008-.7-.023-.894-.066-1.758-.1-2.567-.1a19.182,19.182,0,0,0-11.381,3.219,6.367,6.367,0,0,1-1.824.724c1.394-2.756,3.581-4.548,5.88-6.432l.554-.455a.722.722,0,0,1,.165-.108h.067c.576,0,1.161-.015,1.725-.029s1.135-.028,1.7-.028a12.62,12.62,0,0,1,5.254.9,4.282,4.282,0,0,1,2.4,2.3Z"
              transform="translate(0 0)"
              fill="currentColor"
            />
          </g>
        </svg>
      </i>
    );
  } else {
    return (
      <i className={`rcicon`}>
        <FontAwesomeIcon icon={type} size="lg" />
      </i>
    );
  }
};

const currentState = (state_position, state) => {
  switch (state) {
    case "pending_diagnostic":
      return state_position;
    case "scheduled_scooter_pickup":
      return state_position - 1;
    case "in_diagnostic":
      return state_position - 2;
    case "approve_diagnostic":
      return state_position - 3;
    case "customer_confirmation_needed":
      return state_position - 4;
    case "waiting_for_payment":
      return state_position - 4;
    case "waiting_for_service":
      return state_position - 4;
    case "in_service":
      return state_position - 5;
    case "waiting_for_parts":
      return state_position - 6;
    case "hold":
      return state_position - 7;
    case "waiting_for_pickup":
      return state_position - 7;
    case "completed":
      return state_position - 8;
    case "cancelled":
      return state_position - 10;
    default:
      return state_position;
  }
};

export function contractStateName(aasm_state) {
  let stateName;
  switch (aasm_state) {
    case "in_service":
      stateName = "In service";
      break;
    case "scheduled_scooter_pickup":
      stateName = "Scheduled scooter pickup";
      break;
    case "pending_diagnostic":
      stateName = "Pending diagnostic";
      break;
    case "in_diagnostic":
      stateName = "In diagnostic";
      break;
    case "approve_diagnostic":
      stateName = "Approve diagnostic";
      break;
    case "customer_confirmation_needed":
      stateName = "Customer confirmation needed";
      break;
    case "waiting_for_service":
      stateName = "Waiting for service";
      break;
    // case "waiting_for_invoice":
    //   stateName = "Waiting for invoice";
    // break;
    case "waiting_for_payment":
      stateName = "Waiting for payment";
      break;
    case "hold":
      stateName = "On hold";
      break;
    case "waiting_for_parts":
      stateName = "Waiting for parts";
      break;
    case "completed":
      stateName = "Completed";
      break;
    case "cancelled":
      stateName = "Cancelled";
      break;
    case "waiting_for_pickup":
      stateName = "Waiting for pickup";
      break;
    default:
      stateName = aasm_state;
  }
  return stateName;
}

export const Timeline = ({ state_position, contract_states }) => {
  return (
    <div className="pb-3">
      <Steps
        className="tracker"
        labelPlacement="vertical"
        current={currentState(state_position, contract_states[state_position])}
        state={currentStatus(contract_states[state_position])}
      >
        {printSteps(state_position, contract_states)}
      </Steps>
    </div>
  );
};

export const ContractListItem = compose(
  setDisplayName("ContractListItem"),
  flattenProp("contract"),
  flattenProp("customer"),
  flattenProp("scooter"),
  defaultProps({ role: "staff" }),
  withRouter
)(
  (
    {
      tracking_number,
      aasm_state,
      express,
      key_tag,
      first_name,
      last_name,
      brand,
      model,
      color,
      created_at,
      role,
      state_position,
      contract_states,
      events
    },
    contract
  ) => {
    return (
      <div className="container-fluid overflow-x-hidden">
        <Link to={`/contracts/${tracking_number}`}>
          <div className="row justify-content-between pb-3">
            {role === "staff" && (
              <div className="col-12 col-md-6 text-left">
                <h4 className="text-info">
                  <b>
                    {express && <Icon icon={faAsterisk} />} {tracking_number}
                  </b>
                </h4>
                <label>
                  <i>
                    Created at: {format(parse(created_at), "MM/DD/YYYY HH:mm")}
                  </i>
                </label>
              </div>
            )}
            {(role === "customer" || role === "contact") && (
              <>
                <div className="row">
                  <div className="col-12 col-md-12 pt-1 contract-list-title">
                    <span className="col text-muted pb-0">
                      {"Created at: "}
                      {format(parse(created_at), "MM/DD/YYYY - HH:mm")}
                    </span>
                    <label className="col  px-3">
                      <h4>#{tracking_number}</h4>
                    </label>
                  </div>
                  <div className="px-3 pt-3 pb-0 col-12 col-md-12 text-justify ">
                    <label className="col  px-3 text-center">
                      <h5>
                        {"Your contract is: "}
                        {contractStateName(aasm_state)}
                      </h5>
                    </label>
                    <Timeline
                      className="w-100 text-justify "
                      state_position={state_position}
                      contract_states={contract_states}
                      tracking_number={tracking_number}
                    />
                  </div>
                  <div className="col-12 col-md-12 ">
                    <label>
                      {"Last update: "}
                      {format(
                        parse(events[0].updated_at),
                        "MM/DD/YYYY - HH:mm"
                      )}
                    </label>

                    <div className="row m-0 pt-3 justify-content-center align-content-center">
                      <div className="col-sm-6 col-6 pr-0 selectable">
                        <Link
                          className="btn btn-primary rounded-lg selectable"
                          to={`/contracts/${tracking_number}/tracking`}
                        >
                          View tracker
                        </Link>
                      </div>

                      <div className="col-sm-6 col-6 pl-0  align-self-center">
                        <Link
                          className="btn btn-primary btn-fill rounded-lg selectable"
                          to={`/contracts/${tracking_number}`}
                        >
                          View details
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {/* </div> */}
            {role === "staff" && (
              <Fragment>
                <div className="col-12 col-md-6 text-left">
                  <label>
                    <Icon icon={faUser} /> {`${first_name} ${last_name}`}
                  </label>
                </div>
                <div className="col-12 col-md-6 text-left">
                  <label>
                    <Icon icon={faMotorcycle} />{" "}
                    {`${brand} - ${model} - ${color}`}
                  </label>
                </div>
              </Fragment>
            )}
            {key_tag && role === "staff" && (
              <div className="col-12 col-md-6 text-left">
                <label>
                  <Icon icon={faKey} /> {key_tag}
                </label>
                <div>
                  <label>
                    {contractStateName(aasm_state)}
                  </label>
                </div>
              </div>
            )}
          </div>
        </Link>
      </div>
    );
  }
);

const ContractList = ({ contracts, ...props }) => {
  return (
    <ListGroup flush>
      {contracts.map(contract => (
        <ListGroupItem key={contract.tracking_number}>
          <ContractListItem contract={contract} {...props} />
        </ListGroupItem>
      ))}
    </ListGroup>
  );
};

export default ContractList;
